// extracted by mini-css-extract-plugin
module.exports = {"errorInput":"CategoryRating_errorInput__p4zIc"};